export const LV_LanguageTR={
LangID:{en:'LangID',cs:'LangID',dataType:'number',format:'#0',required:true},
LangName:{en:'LangName',cs:'LangName',dataType:'string',maxLength:1020},
LangTimeStamp:{en:'LangTimeStamp',cs:'LangTimeStamp',dataType:'number',format:'#0'}
}